/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactusContent } from '../../models/contactus-content';

export interface ApiMasterContactusContentGetActiveGet$Params {
}

export function apiMasterContactusContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterContactusContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContactusContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactusContent>>;
    })
  );
}

apiMasterContactusContentGetActiveGet.PATH = '/api/Master/ContactusContent/GetActive';
